/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import apiClient from "../../utils/apiClient";

export const apiAccountTypeList = (): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .get(API_ENDPOINTS.ACCOUNT_TYPE_LIST)
    .then(response => ({ response }))
    .catch(error => ({ error }));
